import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Reveal from './Reveal';
import { BRAND, SHADOW } from '../theme/landingTheme';

// Final conversion band before the footer: repeats the hero email capture for
// visitors who scrolled the whole page.
export default function CtaBand(props) {
  return (
    <Box className="lp-dark-bg" sx={{ py: { xs: 8, sm: 12 }, color: '#fff' }}>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2.5,
          textAlign: 'center',
        }}
      >
        <Reveal>
          <Typography component="h2" variant="h4" sx={{ color: '#fff' }}>
            Start finding profitable Walmart products today
          </Typography>
          <Typography variant="body1" sx={{ color: 'grey.400', mt: 1.5 }}>
            Join 4,000+ Walmart sellers. Full access free for 7 days — no charge until the
            trial ends.
          </Typography>
        </Reveal>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1}
          useFlexGap
          sx={{ pt: 1, width: { xs: '100%', sm: 'auto' }, justifyContent: 'center' }}
        >
          <TextField
            hiddenLabel
            size="small"
            variant="outlined"
            aria-label="Enter your email address"
            placeholder="Your email address"
            name="email"
            sx={{ backgroundColor: '#fff', borderRadius: '10px', minWidth: { sm: '260px' } }}
            inputProps={{
              autoComplete: 'off',
              'aria-label': 'Enter your email address',
            }}
            onChange={(e) => props.setEmail(e.target.value)}
          />
          <Button
            variant="contained"
            className="lp-cta-glow"
            sx={{
              backgroundColor: BRAND.yellow,
              color: BRAND.ink,
              px: 3,
              py: 1,
              width: { xs: '100%', sm: 'auto' },
              boxShadow: SHADOW.cta,
              '&:hover': { backgroundColor: BRAND.yellowDark },
            }}
            onClick={(e) => props.signUp(e)}
          >
            Start Free 7-Day Trial
          </Button>
        </Stack>
        <Typography variant="caption" sx={{ color: 'grey.500' }}>
          Cancel anytime&nbsp;·&nbsp;One plan, everything included
        </Typography>
      </Container>
    </Box>
  );
}
